import { combineReducers } from 'redux';
import authReducer from './authReducer';
import errorReducer from './errorReducer';
import glossaryReducer from './glossaryReducer';
import dialoguesReducer from './dialogueReducer';
import profileReducer from './profileReducer';
import tutorialReducer from './tutorialReducer';
import teacherReducer from './teacherReducer';
import topStudentReducer from './topStudentReducer';
import studentTestimonialReducer from './studentTestimonialReducer';
import newsReducer from './newsReducer';
import userReducer from './userReducer';
import questionReducer from './questionReducer';
import examReducer from './examReducer';
import advisionReducer from './advisionReducer';

export default combineReducers({
  auth: authReducer,
  errors: errorReducer,
  word: glossaryReducer,
  dialogue: dialoguesReducer,
  profile: profileReducer,
  tutorial: tutorialReducer,
  teacher: teacherReducer,
  topStudent: topStudentReducer,
  studentTestimonial: studentTestimonialReducer,
  news: newsReducer,
  user: userReducer,
  question: questionReducer,
  exam: examReducer,
  advision: advisionReducer
});
